import { fetchAuthSession } from "@aws-amplify/auth";
import { useState } from "react";
import axios from "axios";
import {
  ADMIN_CRFA_VALIDATE,
  ADMIN_CRFA_USERS,
} from "../../../../constants/api";

export const useValidateCrfa = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [pendingCrfaList, setPendingCrfaList] = useState([]);

  // Guarda o último usuário da página atual para buscar a próxima página
  const [lastUserSub, setLastUserSub] = useState(null);

  const getUserToken = async () => {
    const session = await fetchAuthSession({
      forceRefresh: true,
    });
    return session.tokens?.idToken?.toString();
  };

  const getPendingCrfa = async (loadMore = false) => {
    try {
      setIsLoading(true);

      const userToken = await getUserToken();

      const params = {
        param: "status",
        value: "pending_approval",
        limit: 5,
      };

      // Adiciona o cursor para buscar a próxima página
      if (loadMore && lastUserSub) {
        params.last_user_sub = lastUserSub;
      }

      const response = await axios.get(ADMIN_CRFA_USERS, {
        params,
        headers: {
          Authorization: userToken,
        },
      });

      // Pega os usuários e o marcador da próxima página
      const { users, last_user_sub } = response.data;

      if (loadMore) {
        // Adiciona os novos usuários
        setPendingCrfaList((currentList) => [...currentList, ...users]);
      } else {
        // Começa uma lista nova
        setPendingCrfaList(users);
      }

      // Guarda o último usuário para usar na próxima chamada
      setLastUserSub(last_user_sub);

      return response.data;
    } catch (error) {
      console.log("Erro ao buscar documento: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const approvedCrfa = async (userSub, status) => {
    try {
      setIsLoading(true);

      const userToken = await getUserToken();

      const payLoad = {
        users_infos: [
          {
            user_sub: userSub,
            status,
          },
        ],
      };

      const response = await axios.post(ADMIN_CRFA_VALIDATE, payLoad, {
        headers: {
          Authorization: userToken,
        },
      });

      return response.data;
    } catch (error) {
      console.log("Erro ao aprovar carteirinha:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const rejectedCrfa = async (userSub, status, reason) => {
    try {
      setIsLoading(true);

      const userToken = await getUserToken();

      const payLoad = {
        users_infos: [
          {
            user_sub: userSub,
            status,
            reason,
          },
        ],
      };

      const response = await axios.post(ADMIN_CRFA_VALIDATE, payLoad, {
        headers: {
          Authorization: userToken,
        },
      });

      return response.data;
    } catch (error) {
      console.log("Erro ao rejeitar carteirinha:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    setIsLoading,
    pendingCrfaList,
    getPendingCrfa,
    approvedCrfa,
    rejectedCrfa,
    lastUserSub,
  };
};
